export type LearnerChoice = "self" | "child" | "children" | "both";

export function learnerChoicesForPlan(maxLearners: number): { value: LearnerChoice; label: string; hint: string }[] {
  if (maxLearners <= 1) {
    return [
      { value: "self", label: "I'm learning", hint: "You use your plan's one learner seat." },
      { value: "child", label: "My child is learning", hint: "Your child uses the learner seat. You keep parent access." },
    ];
  }
  return [
    { value: "self", label: "I'm learning", hint: "You take one learner seat." },
    { value: "children", label: "My children are learning", hint: "Children use the learner seats. You keep parent access." },
    { value: "both", label: "Both of us", hint: "You and your children each take a seat." },
  ];
}
